import type { FaireProductEntity } from "../../entity_types/product";

export const p_nj6xucyhtq: FaireProductEntity = {
  token: "p_nj6xucyhtq",
  type: "product",
  name: "Press for Mahjong Keychain Charm",
  brandToken: "b_vbyfesg45s",
  brandName: "Anders Ruff Design Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/7057d9a9cdf13c0cf9247083111eb5504c13bd10d83308e29367321682b7132f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/052fec3678c3849eb15b0143388e68834e7e304503990df3e8905483b2466249.jpeg",
    "https://cdn.faire.com/fastly/e29cfed1ce497fe5ca29be19c9a8310701d3bd2f8e15dd1ffe594585f3b7ec79.png",
  ],
  priceDollars: 12.5,
  description:
    "Ring for service. Play for keeps.\n\nPart of The Bams & Bubbly Collection, the Press for Mahjong Enamel Keychain Charm is the finishing touch every stylish Mahjong setup deserves. Inspired by vintage hotel key tags, this oversized 3\" enamel charm centers the signature Press for Mahjong crest inside an ornate gold filigree frame — a playful-preppy accent that clips beautifully onto your Mahjong tote, purse, travel bag, zipper pull, or keys. \n\nChoose Hot Pink for a bold, saturated statement or Blush for a softer, more tonal take — both finished with the collection's signature orange accents and luxe gold detailing. Designed to coordinate with the bestselling Bams & Bubbly mat, tile set, and matching accessories, it's the kind of small detail that makes the whole collection feel complete.\n\nPerfect For... \n• Girls' nights\n• Tournaments\n• Hostess gifts\n• Stocking stuffers\n• Everyday bag charm\n\nDesigned exclusively by Anders Ruff Design Co. to coordinate with the full collection — the perfect finishing touch for bags, totes, and travel accessories.\n\nDetails\n• Approx. 3\" tall\n• Premium hard enamel finish\n• Gold-tone metal hardware\n• Secure lobster clasp attachment\n• Clips onto Mahjong bags, totes, purses, zipper pulls & keys\n• Designed exclusively by Anders Ruff Design Co.\n\nPLAY BEAUTIFULLY · GATHER IN STYLE\n\n",
  tags: [],
  msrpDollars: 25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:53.333Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
